Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    badgeSpacing: 4,
    badgeForegroundColor: tokens.themeForegroundPrimaryDefault,
    badgeFontSize: 14,
    badgeFontWeight: 400,
    badgeLineHeight: "18px",
    badgeBorderWidth: 1,
    badgeSizeRegular: 18,
    badgeSizeCompact: 12,
    badgeOnIconOffsetRegular: 4,
    badgeOnIconOffsetCompact: 4,
    badgeBackgroundColorRegularTheme: tokens.themeForegroundAccentDefault,
    badgeBackgroundColorRegularNeutral: tokens.themeForegroundTertiaryDefault,
    badgeBackgroundColorRegularError: "#CC0C39",
    badgeBackgroundColorCompactTheme: tokens.themeForegroundAccentDefault,
    badgeBackgroundColorCompactNeutral: tokens.themeForegroundTertiaryDefault,
    badgeBackgroundColorCompactError: "#CC0C39",
    badgeForegroundColorDefault: tokens.themeForegroundInvertedDefault,
    badgeForegroundColorError: "#FFFFFF",
    badgeFontFamily: "\"Amazon Ember\", \"Amazon Ember Arabic\", Arial, sans-serif",
    badgeFontSizeDefault: 14,
    badgeFontSizeOnIcon: 12,
    badgeFontWeightDefault: 400,
    badgeFontWeightOnIcon: 600,
    badgeBorderColor: tokens.themeBackgroundPrimaryDefault,
    badgeBorderRadius: 999,
    badgeBorderWidthRegular: 1,
    badgeBorderWidthCompact: 2,
    badgeSizeRegularDefault: 20,
    badgeSizeRegularOnIcon: 16,
    badgeSizeCompactDefault: 12,
    badgeSpacingInsetHorizontalDefault: 4,
    badgeSpacingInsetHorizontalOnIcon: 3,
    badgeOnIconOffset: 4
  }
};